import event_photo from "../../images/NFT.png"
import x_logo from "../../images/x-logo.png"
import {TwitterShareButton} from "react-share";

const products = [
    {
        id: 1,
        name: 'Tier 1',
        imageSrc: event_photo,
        date: "3-5 October",
        amount: '07/1000',
        location: 'Black',
        price:"22",

    },
    {
        id: 2,
        name: 'Tier 2',
        imageSrc: event_photo,
        date: "3-5 October",
        amount: '16/1000',
        location: 'Zurich, Zurich',
        price:"56",


    },
    {
        id: 3,
        name: 'Tier 3',
        imageSrc: event_photo,
        date: "14-16 December",
        amount: '112/1000',
        location: 'Dubai, UEA',
        price:"100",

    },

]

export default function Tickets() {
    return (
        <div className="bg-background">
            <div className="mx-auto px-4 py-10 sm:px-6 lg:px-8">
                <h2 className="text-2xl font-title text-white">Ticket Tiers</h2>

                <div className="mt-6 grid grid-cols-1 gap-x-12 gap-y-10 sm:grid-cols-2 lg:grid-cols-3">
                    {products.map((product) => (
                        <div key={product.id} className="group relative">
                            <div className="aspect-w-1 w-full h-80 overflow-hidden lg:aspect-none">
                                <img
                                    src={product.imageSrc}
                                    className="h-full w-full object-cover object-center lg:h-full lg:w-full"
                                />
                            </div>
                            <div className="mt-4 flex justify-between">
                                <div>
                                    <h3 className=" text-white text-2xl not-italic px-1 font-bold leading-7 font-title">
                                        <a href={product.href}>
                                            <span aria-hidden="true" className="absolute inset-0" />
                                            {product.name}
                                        </a>
                                    </h3>
                                    <p className="mt-5 px-1 text-white">Benefits</p>
                                    <ul class="mt-3 list-disc">
                                        <li className="mt-1 mx-10 text-sm text-white">{product.date}</li>
                                        <li className="mt-1 mx-10 text-sm text-white">{product.location}</li>

                                    </ul>
                                    
                                </div>
                                <p className="text-2xl not-italic font-bold leading-7 font-title text-blue">{product.amount}</p>
                            </div>
                            <div className="mt-5 flex">
                                <button className="relative w-full flex items-center justify-center rounded-md bg-blue px-8 py-2 text-sm font-medium text-white">Purchase Ticket {product.price}$</button>
                                
                            </div>
                            <TwitterShareButton className="mt-5 flex w-full" url={'https://o7n24-niaaa-aaaal-qcixa-cai.icp0.io/'} quote={"I will be attending"} hashtag="#FrontRow">
                                <button className="relative w-full flex items-center justify-center border border-transparent rounded-md bg-background px-8 py-2 text-sm font-medium text-white">
                                    Share Attendance to Twitter
                                    <img className="h-7 mx-1" src={x_logo}></img>
                                </button>
                            </TwitterShareButton>
                            
                        </div>
                    ))}
                </div>
            </div>
        </div>
    )
}